import { Dialog } from '@mui/material';
import { useFormik } from 'formik';
import StyledForm from '../formStyle';
import departmentsService from 'services/departmentsService';
import { alertError } from 'utils/helper/appHelper';
import { departmentValidation } from '../validation';

const EditDepartmentDialog = ({
    open,
    setOpen,
    onFinish,
    selectedDepartment,
    isAllow
}) => {
    const formik = useFormik({
        initialValues: {
            name: selectedDepartment.name,
        },
        validate: departmentValidation,
        onSubmit: (values) => {
            submitForm(values);
        },
    });

    const submitForm = async (values) => {
        try {
            const data = await departmentsService.updateDepartments(
                values,
                selectedDepartment.id,
            );
            if (data) {
                onFinish();
            }
        } catch (err) {
            const response = err?.response;
            alertError(response.data?.error);
            setOpen(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableEscapeKeyDown>
            <StyledForm onSubmit={formik.handleSubmit}>
                <h2 className="formTitle">{selectedDepartment.name} 編集</h2>
                <div className="fieldRow">
                    <p>部署名</p>
                    <input
                        autoComplete="off"
                        type="text"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                    ></input>
                    {formik.touched.name && formik.errors.name && (
                        <span className="error">{formik.errors.name}</span>
                    )}
                </div>
                <div className="buttonGroup">
                    <button
                        className="cancelBtn"
                        type="button"
                        onClick={handleClose}
                    >
                        キャンセル
                    </button>
                    <button 
                        className="registerBtn" 
                        type="submit"  
                        disabled={!isAllow}
                    >
                        登録
                    </button>
                </div>
            </StyledForm>
        </Dialog>
    );
};

export default EditDepartmentDialog;
